/**
 checks if the string has at least one lowercase character, one uppercase character and one number, having at least a length of 8 and at most 20
 - (?=.*[a-z]) matches a single character in the range between a (index 97) and z (index 122)
 - (?=.*[A-Z]) matches a single character in the range between A (index 65) and Z (index 90)
 - (?=.*[0-9]) matches a single character in the range between 0 (index 48) and 9 (index 57)
 - {8,20} matches the previous token
 **/
export const passwordPattern = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,20}$/;

// Taken from github.com/angular/angular/blob/c8e4d62882fd014e83cab8e7dca8d26f4d79c280/packages/forms/src/validators.ts#L123
export const emailPattern =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const FORM_FIELDS = {
  EMAIL: "email",
  PASSWORD: "password",
  TERMS_AND_CONDITIONS: "termsAndConditions",
  SUBSCRIBED: "subscribed",
} as const;

export const SIGN_UP_DEFAULT_VALUES = {
  [FORM_FIELDS.PASSWORD]: "",
  [FORM_FIELDS.EMAIL]: "",
  [FORM_FIELDS.TERMS_AND_CONDITIONS]: false,
  [FORM_FIELDS.SUBSCRIBED]: false,
};
